import React, { useState } from "react";
import urls from "../Utils/urls";
import "../css/ContentPage.css";
import "../css/faqPage.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const FAQ_ITEMS = [
  {
    q: "What is Salary Uncle?",
    a: "Salary Uncle is a short-term, unsecured loan offered by Non-Banking Financial Companies (NBFCs) to help individuals meet immediate financial needs.",
  },
  {
    q: "How does Salary Uncle work?",
    a: "Salary Uncle loans are usually small amounts of money, offered without the need for collateral. The entire process is digital — apply online, get instant approval, and receive funds in your bank account quickly.",
  },
  {
    q: "What is the eligibility to apply for a Loan?",
    a: "You must be at least 21 years of age and be a salaried employee or have a steady source of income. Indian residency and a valid bank account in your own name are also required.",
  },
  {
    q: "How much can I borrow through a Salary Uncle Loan?",
    a: "The loan amount typically ranges from ₹5,000 to ₹1,00,000, depending on your income, credit score, and the lending policies. Higher salaries qualify for larger limits.",
  },
  {
    q: "What is the repayment period for a Salary Uncle Loan?",
    a: "Repayment terms generally range from 7 days to 30 days, often aligning with your payday for convenience.",
  },
  {
    q: "Do I need to provide collateral to get a Salary Uncle Loan?",
    a: "No, payday loans are typically unsecured, meaning no collateral is required. Your salary profile is your qualification.",
  },
  {
    q: "What documents are required to apply for a Salary Uncle Loan?",
    a: "Common documentation includes: Proof of identity (Aadhaar card, PAN, voter ID), Proof of address (electricity bill, rent agreement), Proof of income (salary slips, bank statements), and Employment proof.",
  },
  {
    q: "How fast can I receive the loan amount?",
    a: "Once your loan application is approved, the funds are typically disbursed quickly — often within 24–48 hours. In many cases the loan amount is credited to your bank account within a few hours.",
  },
  {
    q: "What happens if I miss the loan repayment date?",
    a: "If you're unable to repay your loan on time, it's essential to contact Salary Uncle immediately to discuss your options. Depending on the circumstances, we may offer repayment extensions or alternative arrangements to help you manage your debt.",
  },
  {
    q: "Can I prepay or close the loan before the due date?",
    a: "Yes, Salary Uncle allows you to repay the loan before the due date. However, there may be a reduced interest benefit on early closure.",
  },
];

const FaqAccordion = ({ q, a, open, onClick }) => (
  <div className={`fq-item ${open ? "fq-item--open" : ""}`} onClick={onClick}>
    <div className="fq-q">
      <span>{q}</span>
      <span className="fq-toggle">
        {open ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"/></svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
        )}
      </span>
    </div>
    {open && <div className="fq-a">{a}</div>}
  </div>
);

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <>
      <Helmet>
        <title>Salary Loan FAQs — Quick Answers to Your Questions | Salary Uncle</title>
        <meta property="og:title" content="Salary Loan FAQs — Quick Answers to Your Questions | Salary Uncle" />
        <meta name="description" content="Find answers about Salary Uncle loans, eligibility, documents, loan amounts, repayment terms, and more. Learn how our short-term loans work — fast and easy!" />
        <meta property="og:description" content="Find answers about Salary Uncle loans, eligibility, documents, loan amounts, repayment terms, and more. Learn how our short-term loans work — fast and easy!" />
        <link rel="canonical" href={`${urls.SITE_URL}/faq`} />
      </Helmet>

      <div className="page_wrapper">
        <div className="page_banner_wrapper">
          <div className="page_banner_wrapper_overlay">
            <h2>FAQ's</h2>
            <div style={{ marginTop: "10px" }}>
              <Link to="/" style={{ color: "#6dd05a", fontWeight: "600", marginTop: "10px", textDecoration: "none" }}>
                Home
              </Link>
              <span style={{ color: "white", fontSize: "16px", margin: "0 10px" }}>→</span>
              <span style={{ color: "white", fontWeight: "600", fontSize: "16px" }}>Faq's</span>
            </div>
          </div>
        </div>

        <div className="fq-wrap">
          <div className="fq-inner">
            <div className="fq-head">
              <span className="fq-tag">FAQ</span>
              <h1>Frequently Asked Questions</h1>
              <p>Tap on any question to see the answer.</p>
            </div>

            <div className="fq-list">
              {FAQ_ITEMS.map((item, i) => (
                <FaqAccordion
                  key={i}
                  q={item.q}
                  a={item.a}
                  open={openIdx === i}
                  onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
